import React, { useState } from "react";
import { FieldType, Unit } from "../../../services/helpers/types";
import SelectField from "../../molecules/SelectField/SelectField";
import NumberField from "../NumberField/NumberField";
import { useTranslation } from "react-i18next";
import { getAddNumberUnitField } from "../AddNumberNumberField/helpers";

interface AddNumberFieldProps {
  field?: FieldType;
  onFieldChange: (name: string, value?: string) => void;
}

const AddNumberField = (props: AddNumberFieldProps) => {
  const { field, onFieldChange } = props;

  const { t } = useTranslation();

  const [defaultValue, setDefaultValue] = React.useState(
    field?.defaultValue ?? undefined,
  );

  const [unit, setUnit] = useState<Unit | undefined>(field?.unit ?? undefined);

  const handleSelectUnit = (value: string) => {
    setUnit(value as Unit);
    onFieldChange("unit", value);
  };

  const handleDefaultValueChange = (value?: string) => {
    setDefaultValue(value);
    onFieldChange("defaultValue", value);
  };

  return (
    <>
      <div className="dui-example-field">
        <div className="dui-example-field-title">{t("defaultValue")}:</div>
        <NumberField
          field={field}
          value={defaultValue}
          customUnit={unit}
          onChange={handleDefaultValueChange}
          placeholder={t("defaultValuePlaceholder")}
        />
      </div>
      <div className="dui-example-field">
        <div className="dui-example-field-title">{t("unit")}:</div>
        <SelectField
          value={unit}
          onChange={handleSelectUnit}
          field={getAddNumberUnitField(t)}
        />
      </div>
    </>
  );
};

export default AddNumberField;
